import React from 'react';

import { QuestionInfo } from 'components/assessment/common/QuestionInfo';
import { RadioField } from 'components/ui/form-fields';
import cn from 'classnames';

type YesNoQuestionStepProps = {
  title: string;
  currentAnswer: boolean | null;
  onSelect: (isTransferred: boolean) => void;
};

export const YesNoQuestionStep: React.FC<YesNoQuestionStepProps> = ({ title, onSelect, currentAnswer }) => {
  return (
    <div>
      <QuestionInfo title={title} />
      <div
        className={cn(
          'flex items-center justify-between gap-3 mb-3 self-stretch border  rounded-xl dark:hover:bg-white-400/10 dark:hover:border-white-400/20',
          currentAnswer === true
            ? 'border-gray-800 bg-white-400 dark:bg-white-400/20 dark:border-white-400/20'
            : 'bg-white-400/80 dark:bg-gray-900 border-transparent',
        )}
      >
        <RadioField
          containerClassName="w-full pl-5 pr-3 py-[16px] md:py-[22px]"
          label="Yes"
          name=""
          value={currentAnswer ? 1 : 0}
          checked={currentAnswer === true}
          onChange={event => onSelect(true)}
        />
      </div>
      <div
        className={cn(
          'flex items-center justify-between gap-3 mb-3 self-stretch border  rounded-xl dark:hover:bg-white-400/10 dark:hover:border-white-400/20',
          currentAnswer === false
            ? 'border-gray-800 bg-white-400 dark:bg-white-400/20 dark:border-white-400/20'
            : 'bg-white-400/80 dark:bg-gray-900 border-transparent',
        )}
      >
        <RadioField
          containerClassName="w-full pl-5 pr-3 py-[16px] md:py-[22px]"
          label="No"
          name=""
          value={!currentAnswer ? 1 : 0}
          checked={currentAnswer === false}
          onChange={event => onSelect(false)}
        />
      </div>
    </div>
  );
};
